import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { LicencaEspecialAPI } from "@/api/licencaEspecial.api";
import { AutorizacaoFretamento } from "@/models/autorizacaoFretamento";
import { PendenciaApi } from "@/api/pendencia.api";
import { VeiculoPendencia } from "@/models/veiculoPendencia";

const pendenciaApi = new PendenciaApi();

const buscarPendencias = (
  cnpj: string,
  token: string,
  recaptcha: string,
  placa: string
): AxiosObservable<VeiculoPendencia[]> => {
  return pendenciaApi.buscarPendencias(cnpj, token, recaptcha, placa);
};

const listarPlacas = (cnpj: string): AxiosObservable<string[]> => {
  return pendenciaApi.listarPlacas(cnpj);
};

const buscarMultas = (
  cnpj: string,
  placa: string,
  page: number,
  size: number
): AxiosObservable<any> => {
  return pendenciaApi.buscarMultas(cnpj, placa, page, size);
};

export default {
  buscarPendencias,
  listarPlacas,
  buscarMultas
};
